import Bugsnag from '@bugsnag/js';

const STALE_RECOVERY_WINDOW_MS = 30 * 1000;
const attempts = new Map();

export const canAttemptStaleRecovery = (checkoutId) => {
  if (!checkoutId) return false;
  const last = attempts.get(checkoutId);
  if (!last) return true;
  return Date.now() - last > STALE_RECOVERY_WINDOW_MS;
};

export const markStaleRecoveryAttempt = (checkoutId) => {
  if (!checkoutId) return;
  attempts.set(checkoutId, Date.now());
  if (attempts.size > 50) {
    const cutoff = Date.now() - STALE_RECOVERY_WINDOW_MS;
    attempts.forEach((ts, id) => {
      if (ts < cutoff) attempts.delete(id);
    });
  }
};

// eslint-disable-next-line no-underscore-dangle
export const __resetStaleRecoveryForTests = () => {
  attempts.clear();
};

const notifyWarning = (message, metadata) => {
  Bugsnag.notify(new Error(message), (event) => {
    // eslint-disable-next-line no-param-reassign
    event.severity = 'warning';
    event.addMetadata('staleCheckout', metadata);
  });
};

export const notifyStaleRecovered = ({
  checkoutId,
  source,
  status,
  errorCode,
}) => {
  notifyWarning('consumer.checkout: stale id auto-recovered', {
    checkoutId,
    source,
    status,
    errorCode: errorCode || null,
    recoveryOutcome: 'recovered',
  });
};

export const notifyStaleRetryExhausted = ({
  checkoutId,
  source,
  status,
  errorCode,
}) => {
  notifyWarning('consumer.checkout: stale id, retry exhausted', {
    checkoutId,
    source,
    status,
    errorCode: errorCode || null,
    recoveryOutcome: 'retry_exhausted',
  });
};

export const notifyStaleDeferred = ({
  checkoutId,
  source,
  status,
  errorCode,
}) => {
  notifyWarning('consumer.checkout: stale id deferred', {
    checkoutId,
    source,
    status,
    errorCode: errorCode || null,
    recoveryOutcome: 'deferred',
  });
};

const notifyAmountMismatch = (message, metadata) => {
  Bugsnag.notify(new Error(message), (event) => {
    // eslint-disable-next-line no-param-reassign
    event.severity = 'warning';
    event.addMetadata('amountMismatch', metadata);
  });
};

export const notifyAmountMismatchRecovered = ({
  checkoutId,
  source,
  piAmount,
  expectedAmount,
}) => {
  notifyAmountMismatch(
    'consumer.checkout: payment intent amount mismatch auto-recovered',
    {
      checkoutId,
      source,
      piAmount,
      expectedAmount,
      delta:
        typeof piAmount === 'number' && typeof expectedAmount === 'number'
          ? piAmount - expectedAmount
          : null,
      recoveryOutcome: 'recovered',
    }
  );
};

export const notifyAmountMismatchRetryExhausted = ({
  checkoutId,
  source,
  piAmount,
  expectedAmount,
}) => {
  notifyAmountMismatch(
    'consumer.checkout: payment intent amount mismatch, retry exhausted',
    {
      checkoutId,
      source,
      piAmount,
      expectedAmount,
      delta:
        typeof piAmount === 'number' && typeof expectedAmount === 'number'
          ? piAmount - expectedAmount
          : null,
      recoveryOutcome: 'retry_exhausted',
    }
  );
};
